export const notACampusEnvList = ["LITECAMPUS", "PMCG", "EQUATORIAL"];
export const isPMCGEnv = process.env.REACT_APP_CAMPUS === "PMCG";
export const isEQUATORIALEnv = process.env.REACT_APP_CAMPUS === "EQUATORIAL";
export const isLITECAMPUSEnv = process.env.REACT_APP_CAMPUS === "LITECAMPUS";
export const isNotACampus = notACampusEnvList.includes(
  process.env.REACT_APP_CAMPUS
);
